// extracted by mini-css-extract-plugin
export var hideEditor = "_h8-2";
export var infoIcon = "_h8-3";
export var label = "_h8-1";
export var labelContainer = "_h8-0";
export var readonlyText = "_h8-4";